import {
  Component,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Capacitor, PluginListenerHandle } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { ScrollLockService } from "@app/presentation/services/scroll-lock.service";

@Component({
  standalone: true,
  imports: [TranslateModule, LucideAngularModule],
  selector: "app-dialog-overlay",
  templateUrl: "./dialog-overlay.component.html",
})
export class DialogOverlayComponent implements OnInit, OnDestroy {
  constructor(
    private ngZone: NgZone,
    private scrollLock: ScrollLockService
  ) {}

  @Output() closed = new EventEmitter<boolean>();

  protected keyboardHeight = 0;
  private keyboardShowHandle?: PluginListenerHandle;
  private keyboardHideHandle?: PluginListenerHandle;

  async ngOnInit() {
    this.scrollLock.lock();

    if (Capacitor.getPlatform() === "web") return;

    this.keyboardShowHandle = await Keyboard.addListener(
      "keyboardWillShow",
      (info) => {
        this.ngZone.run(() => {
          this.keyboardHeight = info.keyboardHeight;
        });
      },
    );
    this.keyboardHideHandle = await Keyboard.addListener(
      "keyboardWillHide",
      () => {
        this.ngZone.run(() => {
          this.keyboardHeight = 0;
        });
      },
    );
  }

  ngOnDestroy() {
    this.scrollLock.unlock();
    this.keyboardShowHandle?.remove();
    this.keyboardHideHandle?.remove();
  }

  ignoreParentClick(e: Event) {
    e.stopPropagation();
  }
}
